import generateCalendar from 'antd/lib/calendar/generateCalendar';
import { Dayjs } from 'dayjs';
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import 'antd/es/date-picker/style/index';

const AntCalendar = generateCalendar<Dayjs>(dayjsGenerateConfig);

export default AntCalendar;
